import { SmokeRing } from "@paper-design/shaders-react";
import { useEffect, useState } from "react";

export function Shader() {
  const [scroll, setScroll] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      const progress = max > 0 ? window.scrollY / max : 0;
      setScroll(progress);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Scroll-driven values
  const scale = 1.4 + scroll * 1.2; // grows as you scroll
  const rotation = scroll * Math.PI * 2; // full spin over the page
  const thickness = 0.55 + scroll * 0.35;
  const innerShape = 0.7 - scroll * 0.4;
  const speed = 0.5 + scroll * 1.5;
  const noiseScale = 3 + scroll * 4;

  return (
    <div style={{ position: "fixed", inset: 0, pointerEvents: "none" }}>
      <SmokeRing
        fit={"cover"}
        scale={scale}
        rotation={rotation}
        offsetX={0}
        offsetY={0}
        speed={speed}
        originX={0.5}
        originY={0.5}
        worldWidth={0}
        worldHeight={0}
        colorBack={"#000000"}
        colors={["#ffffff"]}
        noiseScale={noiseScale}
        noiseIterations={8}
        radius={0.35}
        thickness={thickness}
        innerShape={Math.max(0.05, innerShape)}
        style={{ width: "100%", height: "100%" }}
      />
    </div>
  );
}

export default Shader;